import { Component, Input } from '@angular/core';
import { Projection } from '../models';
import { FormatDatePipe } from 'src/app/miscellaneous/pipes/format-date.pipe';
import { Store } from '@ngrx/store';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-bobby-calves-calves-picked-up-paper-declaration-card',
  templateUrl: './bobby-calves-calves-picked-up-paper-declaration-card.component.html',
  styleUrls: ['./bobby-calves-calves-picked-up-paper-declaration-card.component.scss'],
})
export class BobbyCalvesPickedUpPaperDeclarationCardComponent {
  @Input() pickup: Projection.Pickup;

  constructor(
    private readonly store: Store,
    private readonly dateFormatter: FormatDatePipe,
    private readonly navigationService: NavigationService,
  ) {}

  public get date(): string {
    return this.dateFormatter.transform(this.pickup.date, 'dwdm');
  }
}